// import core & vendor packages below
import { Modal, Button } from 'react-bootstrap';

// import components below
import ModalUI from 'components/UI/ModalUI';

// import assets below
import './StartDischargeModal.scss';
import { ReactComponent as CloseSVG } from 'assets/svg/circle-xmark.svg';

// main componet
const StartDischargeModal = (props) => {
  const { status, onToggle, onConfirm } = props;

  return (
    <div className='startDischargeModal'>
      <ModalUI>
        <Modal.Dialog>
          <Modal.Header>
            <h4>CONFIRM START OF DISCHARGE PROCESS</h4>
            <Button onClick={() => onToggle(!status)} variant='transparent'>
              <CloseSVG />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className='startDischargeModal__content'>
              <div className='startDischargeModal__header'>
                <h1>Warning!</h1>
              </div>
              <div className='startDischargeModal__body'>
                <h6>You are about to start the discharge process.</h6>
                <h5>Are you sure you want to proceed?</h5>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant='light-blue'
              onClick={() => {
                onToggle(!status);
                onConfirm((prevState) => !prevState);
              }}
            >
              Proceed
            </Button>
            <Button onClick={() => onToggle(!status)} variant='cancel'>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </ModalUI>
    </div>
  );
};

export default StartDischargeModal;
